import apiGetRequest from './api-get-request'
import getWithToken from './get-with-token'

/**
 * Helper function to create API functions that support both authenticated and shareCode-based access
 * @param {string} endpoint - The API endpoint path
 * @returns {Function} - API function that handles both auth token and shareCode parameter
 */
const apiWithOptionalCode = (endpoint) => {
  return (params = {}) => {
    // If shareCode parameter is provided, use public API without token
    if (params.shareCode) {
      const queryString = new URLSearchParams(params).toString()
      return apiGetRequest(`${endpoint}?${queryString}`)()
    }
    
    // Otherwise use authenticated API
    return getWithToken(endpoint)(params)
  }
}

/**
 * Helper for customer-specific endpoints
 * @param {string} path - The path after /customer/:id/
 * @returns {Function} - API function for customer endpoints
 */
const customerApiWithOptionalCode = (path) => {
  return (id, params = {}) => {
    const endpoint = `/customer/${id}/${path}`
    
    // If shareCode parameter is provided, use public API without token
    if (params.shareCode) {
      const queryString = new URLSearchParams(params).toString()
      return apiGetRequest(`${endpoint}?${queryString}`)()
    }
    
    // Otherwise use authenticated API
    return getWithToken(endpoint)(params)
  }
}

export { apiWithOptionalCode, customerApiWithOptionalCode }
export default apiWithOptionalCode